import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { userContext } from '../App';


const Root = () => {
    const [isUser, setIsUser] = useContext(userContext);
    //let api = false;

    const getRootUrl = () => {
        let url = 'auth/login';
        // check if user logged in or not and return url accordingly
        if (isUser=== false) {
            url = 'auth/login';
        } else {
            url = 'dashboard';
        }
        return url;
    };

    const url = getRootUrl();

    return <Redirect to={`/${url}`} />;
};

export default Root; 
